import {clearFeedbacksByName, getInputsByName} from "../helpers/forms";

function initProfileForm(formElement) {
	// init form


	// Form methods
	return {
		formElement,
		formFields: [
			'first_name',
			'last_name',
			'email',
			'password',
		],
		inputs() {
			return getInputsByName(formElement, this.formFields);
		},
		clearFeedbacks() {
			return clearFeedbacksByName(formElement, this.formFields);
		},
		postUrl() {
			return formElement.dataset.url;
		},
		successUrl() {
			return formElement.dataset.successUrl;
		}
	};
}

export {initProfileForm}
